module.exports = __webpack_public_path__ + "static/media/marsbasen-eksplosionen-skitse-a.png";